import { getItemOrDefaultToValue, getPersonName } from 'utils/details';
import { displayTime } from '../../time';
import { getElapsedTime } from '../../details';
import { getStatusValue } from '../../helper/patrol';
import { DEFAULT_EMPTY_VALUE /*PAGE_NAME*/ } from '../../constants';
import { startsWith } from 'lodash';
import { TASK_EVIDENCE_TYPE } from '../../constants/task';
import {
  collectedEvidenceColumns,
  /*evidenceColumns,*/
} from '../CleanerTask/CleanerTaskDetails';
import { formatContents } from 'utils/helper/baseTasks';

const countCheckPoints = locations => {
  if (!locations) return 0;
  return locations.filter(
    location => !location.definedLocation.point.isWaypoint,
  ).length;
};

const checkIfLocPatrolledAndEvidenceAttached = loc => {
  return (
    Boolean(!loc.definedLocation.taskId && loc.timestamp) || //checks if cp is patrolled and there is no evidence attached
    Boolean(
      // has evidence attached - is patrolled - isSuccessfully uploaded outside TaskId(taskId)
      loc.definedLocation.taskId && loc.timestamp && loc.taskId,
    )
  );
};

const getCheckpointVisualInfo = ({ firstLoc, otherLoc }) => {
  const firstLocation = [
    { value: 1, active: checkIfLocPatrolledAndEvidenceAttached(firstLoc) },
  ];
  const nextLocations = otherLoc.reduce((nextLocations, location) => {
    if (!location.definedLocation.point.isWaypoint) {
      if (location.timestamp !== null) {
        nextLocations.push({
          value: location.definedLocation.checkPointSequence,
          active: checkIfLocPatrolledAndEvidenceAttached(location),
        });
      } else {
        nextLocations.push({
          value: location.definedLocation.checkPointSequence,
          active: false,
        });
      }
    }
    return nextLocations;
  }, []);
  return firstLocation.concat(nextLocations);
};

export const transform = ({ data, evidence, currentTime, timeZone }) => {
  const evidenceContent = item => {
    if (
      item.completed &&
      item.contents &&
      (item.type === TASK_EVIDENCE_TYPE.OPTION_SINGLE.id ||
        item.type === TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id ||
        item.type === TASK_EVIDENCE_TYPE.SIGNATURE.id)
    ) {
      return formatContents(item.contents);
    } else if (item.completed && item.contents) {
      //for other type if evidence like image, audio, text etc
      return item.contents;
    }
    // if not completed then '-'
    return DEFAULT_EMPTY_VALUE;
  };
  return {
    generalInfo: {
      id: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'patrolId', '-'),
      },
      businessClientName: {
        type: 'text',
        value: data.patrolDefinition.businessClient
          ? getItemOrDefaultToValue(
              data.patrolDefinition.businessClient,
              'businessClientName',
              '-',
            )
          : '-',
      },
      siteName: {
        type: 'text',
        value: data.patrolDefinition.site
          ? getItemOrDefaultToValue(data.patrolDefinition.site, 'siteName', '-')
          : '-',
      },

      patrolName: {
        type: 'text',
        value: getItemOrDefaultToValue(
          data.patrolDefinition,
          'definitionName',
          '-',
        ),
      },
      timeStarted: {
        type: 'text',
        value: displayTime({
          timestamp: getItemOrDefaultToValue(data, 'startTime', '-'),
          timeZone,
        }),
      },
      timeEnded: {
        type: 'text',
        value: startsWith(data.currentStatus, 'RESOLVED')
          ? displayTime({
              timestamp: getItemOrDefaultToValue(
                data,
                'currentStatusTimestamp',
                '-',
              ),
              timeZone,
            })
          : DEFAULT_EMPTY_VALUE,
      },
      patrollerName: {
        type: 'text',
        value: getPersonName(data.patroller.general),
      },
      elapsedTime: {
        type: 'text',
        value: getElapsedTime(data, currentTime),
      },
      status: {
        type: 'text',
        value: getStatusValue(data),
      },
    },
    detailedInfo: {
      numberOfCheckpoints: {
        type: 'text',
        value:
          data.firstLocation.definedLocation !== null
            ? countCheckPoints(data.locations) + 1
            : countCheckPoints(data.locations),
      },
      checkpointsVisualDetail: {
        type: 'progress-bar',
        value: getCheckpointVisualInfo({
          firstLoc: data.firstLocation,
          otherLoc: data.locations,
        }),
      },
      ...(evidence &&
        evidence.length > 0 && {
          evidence: {
            type: 'list-data',
            value: {
              data: evidence.map(item => ({
                type: TASK_EVIDENCE_TYPE[item.type].name,
                completed: item.completed,
                description: item.description,
                contents: evidenceContent(item),

                timestamp:
                  item.timestamp && item.completed
                    ? displayTime({ timestamp: item.timestamp })
                    : DEFAULT_EMPTY_VALUE,
              })),
              //depends on if it is on Managerial or Not.
              columns: collectedEvidenceColumns,
            },
          },
        }),
    },
    others: {
      proximityAlertDisabled: {
        value: data.patrolDefinition.proximityAlertDisabled,
      },
      currentStatus: {
        value: data.currentStatus,
      },
      patrollerID: {
        value: data.patroller.general.id,
      },
    },
  };
};
